import HttpService from "./htttp.service";

class TemplatesService {
  getTemplates = async (query, cancelToken) => {
    const endpoint = "sheet-templates";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createTemplate = async (payload) => {
    const endpoint = "sheet-templates";
    return await HttpService.post(endpoint, payload);
  };

  removeTemplate = async (id) => {
    const endpoint = "sheet-templates/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateTemplate = async (id, payload) => {
    const endpoint = "sheet-templates/" + id;
    return await HttpService.put(endpoint, payload);
  };
}

export default new TemplatesService();
